import { Component } from "react";
import { Typography, Container, Box } from "@mui/material";
import { Header } from "../../shared/Header";
import { useAirbrake } from "../../context/AirbrakeContext";

const ErrorBoundaryWrapper = (props) => {
  const airbrake = useAirbrake();
  return <ErrorBoundary airbrake={airbrake} {...props} />;
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });

    if (process.env.NODE_ENV !== "development") {
      // Send error to Airbrake using the prop
      this.props.airbrake.notify({
        error: error,
        params: { info },
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container>
          <Header />
          <Box mt="32px" textAlign="center">
            <Typography variant="h2">
              We're sorry, something went wrong
            </Typography>
            <Typography paragraph>
              Please try to refresh the page and try again.
            </Typography>
          </Box>
        </Container>
      );
    }
    return this.props.children;
  }
}

export { ErrorBoundaryWrapper as ErrorBoundary };
